<template>
  <v-form ref="form" :value="valid" @input="v => $emit('update:valid', v)">
    <v-row>
      <v-col cols="12" sm="9">
        <v-text-field
          filled
          class="no-before"
          hide-details="auto"
          dense
          label="Nom du gabarit"
          :value="name"
          @change="v => $emit('update:name', v)"
          required
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="3">
        <v-row no-gutters dense justify="end">
          <v-checkbox
            label="Gabarit par défaut"
            v-model="getIsDefaultModel"
            hide-details="auto"
          ></v-checkbox>
        </v-row>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
export default {
  name: "InventoryTemplateFields",
  props: {
    name: {
      required: true
    },
    is_default: {
      type: Boolean,
      required: true
    },
    valid: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    getIsDefaultModel: {
      get() {
        return this.is_default;
      },
      set(v) {
        this.$emit("update:is_default", v);
      }
    }
  }
};
</script>

<style></style>
